/**
 * GameBackground Class
 *
 *
 */

(function () {
  class GameBackground extends PIXI.Container {
    constructor() {
      super();

      this._starsEmitterContainer = undefined;
      this._starsEmitter = undefined;
      this._initialised = false;
      this.visible = false;

      this._colorMatrixFilter = new PIXI.filters.ColorMatrixFilter();
      this.filters = [this._colorMatrixFilter];
      this.setHueToPerc(0);
    }

    grabReferences() {
      this._jsonPath = this.name;
      this._starsEmitterContainer = resourceManager.get(this._jsonPath + ':starsEmitterContainer');
    }

    createAndAddEmitters() {
      this._starsEmitter = particleManager.createEmitter('starsEmitter', this._starsEmitterContainer, 0, 0, false);
    }

    stopEmitters() {
      this._starsEmitter.emitter.particleEmitter.emit = false;
      this._starsEmitter.emitter.visible = false;
    }

    init(json) {
      if (!this._initialised) {
        this.grabReferences();
        this.createAndAddEmitters();
        this.interactiveChildren = false;
        this._initialised = true;
      }
    }

    // 0 to 1
    setHueToPerc(perc) {
      const hue = 60 * perc;
      this._colorMatrixFilter.hue(hue, false);
      if (hue === 0) {
        this._colorMatrixFilter.enabled = false;
      } else {
        this._colorMatrixFilter.enabled = true;
      }
    }
  }

  var creator = function (json) {
    return new GameBackground();
  };

  var initialiser = function (json, container) {
    messageBus.subscribe('spinner:GameConfigEvent', () => {
      container.init(json);
    });
  };

  var filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('GameBackground', creator, initialiser, filesRequired);
})();
